import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useLocation } from "react-router-dom";

import {
  getTimelineList,
  setCreateNewMeetingPage,
  processdeleteMeeting,
  clearState,
} from "../../redux/actions/meetingActions/MeetingAction";
import {
  Button,
  Popover,
  OverlayTrigger,
  Accordion,
  Tooltip,
} from "react-bootstrap";
import {
  customName,
  sliceTextFromHTML,
  formatDate,
  getColorFromId,
} from "../../helpers/commonHelpers";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import "./style/timeLine.css";
import { logOut } from "../../redux/actions/authActions/authAction";
import { useNavigate } from "react-router-dom";
// added for meeting dropdown
import Dropdown from "react-bootstrap/Dropdown";
import MeetingDropDown from "../Meeting/MeetingDropDown";
import { processCancelMeeting } from "../../redux/actions/meetingActions/MeetingAction";
import Alert from "../Common/Alert";
import RescheduleMeetingModal from "../Meeting/RescheduleMeetingModal";
import ResendMeetingDetailsModal from "../Meeting/ResendMeetingDetailsModal";
import CancelMeetingModal from "../Meeting/CancelMeetingModal";
import DeleteMeetingModal from "../Meeting/DeleteMeetingModal";
import BackButton from "../Common/Backbutton";
import TimelineHeader from "../Common/TimelineHeader";
import AssignedAttendeesModal from "../Meeting/AssignedAttendeesModal";

const TimelinePage = (props) => {
  let { meetingId } = useParams();
  const location = useLocation();
  const camefromPreviousPage = location.state?.camefromPreviousPage || false;
  const stateData = location.state;
  const accessToken = localStorage.getItem("accessToken");
  const dispatch = useDispatch();
  const employeeData = useSelector((state) => state.user);
  const meetingData = useSelector((state) => state.meeting);
  const accordionBodyRef = useRef(null);
  const beforeLineRef = useRef(null);
  const [activeKey, setActiveKey] = useState("0");
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [meetingIds, setMeetingIds] = useState(null);
  const [meetingd, setmeeting] = useState(null);
  const [isResendMeetingDetailsModalOpen, setIsResendMeetingDetailsModalOpen] =
    useState(false);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [isDeleteMeetingModalOpen, setIsDeleteMeetingModalOpen] =
    useState(false);

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [attendeesData, setAttendeesData] = useState([]);
  const loginUserData = useSelector((state) => state.user);
  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggle = (key) => {
    const isOpen = activeKey === key ? null : key;
    setActiveKey(isOpen);
    setTimeout(() => {
      if (accordionBodyRef.current && beforeLineRef.current) {
        const height = accordionBodyRef.current.offsetHeight;
        beforeLineRef.current.style.setProperty(
          "--before-height",
          `${height}px`
        );
      }
    }, 300);
  };

  useEffect(() => {
    if (accordionBodyRef.current && beforeLineRef.current) {
      const height = accordionBodyRef.current.offsetHeight;
      beforeLineRef.current.style.setProperty("--before-height", `${height}px`);
    }
  }, []);
  useState(false);

  let meeting = null;

  const navigate = useNavigate();
  const authData = useSelector((state) => state.auth);
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }

  const myDivRef = useRef(null);
  useEffect(() => {
    document.title = "View Minutes: MinutesVault";
    dispatch(getTimelineList(meetingId, accessToken));

    return () => {};
  }, []);

  const isMeetingOrganiser =
    meetingData?.timeLineDatas?.parentMeetingDetails?.createdById?.toString() ===
    employeeData?.userData?._id?.toString()
      ? true
      : false;

  if (meetingData?.timeLineDatas?.followonMeetingDetails) {
    const filteredMeeting =
      meetingData?.timeLineDatas?.followonMeetingDetails?.filter(
        (meeting) => meeting._id === stateData?.meetingId
      );

    meeting = filteredMeeting?.length !== 0 ? filteredMeeting[0] : null;
  }
  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee.name} / {attendee?.email}
      </Tooltip>
    );
  };
  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };

  const handleCancelModal = (meetingId) => {
    setMeetingIds(meetingId);
    setIsCancelModalOpen(true);
  };
  const handleResendMeetingDetailsModal = (meeting) => {
    setmeeting(meeting);

    setIsResendMeetingDetailsModalOpen(true);
  };
  const handleCloseModal = (meetingId) => {
    setMeetingIds(meetingId);
    setIsCloseModalOpen(true);
  };

  const handleRescheduleModal = (meeting) => {
    setmeeting(meeting);
    setIsRescheduleModalOpen(true);
  };

  //modals for meeting dropdown
  const handleCancelMeeting = async (remarks) => {
    const result = await dispatch(
      processCancelMeeting(meetingIds, { remarks }, accessToken)
    );
    if (result?.status) {
      setMeetingIds(null);
      setIsCancelModalOpen(false);
      dispatch(getTimelineList(meetingId, accessToken));
    }
  };

  ////////////// delete meeting //////////////

  const handleDeleteModal = (meetingId) => {
    setMeetingIds(meetingId);
    setIsDeleteMeetingModalOpen(true);
  };

  const handleDeleteMeeting = async () => {
    const result = await dispatch(
      processdeleteMeeting(meetingIds, accessToken)
    );
    if (result?.status) {
      setMeetingIds(null);
      setIsDeleteMeetingModalOpen(false);

      navigate("/meeting-list");
    }
  };
  const followonDetails =
    meetingData?.timeLineDatas?.followonMeetingDetails || [];

  let previousMeetingData = undefined;

  if (followonDetails.length > 1) {
    previousMeetingData = [...followonDetails]
      .reverse()
      .find((item) => item.isActive === true);
  }

  const followOnMeetingCount = meetingData?.timeLineDatas
    ?.followonMeetingDetails
    ? meetingData?.timeLineDatas?.followonMeetingDetails?.length - 1
    : 0;

  useEffect(() => {
    const scrollId = location.state?.scrollToId;
    if (
      scrollId &&
      meetingData?.timeLineDatas?.followonMeetingDetails?.length
    ) {
      setTimeout(() => {
        const element = document.getElementById(scrollId);
        if (element) {
          const yOffset = -80;
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 300);
    }
  }, [location.state, meetingData?.timeLineDatas?.followonMeetingDetails]);

  const handleClick = (event) => {
    if (event.ctrlKey) {
      event.preventDefault(); // Prevents opening in new tab
      event.stopPropagation(); // Prevents bubbling up if needed

      return;
    }

    dispatch(clearState(false));
    dispatch(
      setCreateNewMeetingPage({
        status: true,
        isClearingleMeetingDetails: false,
      })
    );
  };

  const setModalStatus = (value, action) => {
    // if (meeting?.attendees?.length !== 0) {
    setIsModalOpen(value);
    setAttendeesData(action.assignedUser);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-heading d-flex justify-content-between align-items-center">
          <h4 className="">Timeline</h4>
          <div className="agenda-btn-icon screen-hide-380 gap-8px g-10">
            {(isMeetingOrganiser === true ||
              employeeData?.userData?.isAdmin === true ||
              meetingData?.timeLineDatas?.parentMeetingDetails?.createdById ===
                employeeData?.userData?._id) &&
            meetingData?.timeLineDatas?.parentMeetingDetails?.meetingStatus
              ?.status === "closed" ? (
              <div className="meeting-1-details timiline-button resp-width-auto">
                <Link
                  to="/create-meeting"
                  state={{
                    followOnMeetingCount: followOnMeetingCount,
                    isNewMeeting: true,
                    parentMeetingData:
                      meetingData?.timeLineDatas?.parentMeetingDetails,
                    followOnMeetings:
                      meetingData.timeLineDatas.followonMeetingDetails,
                    camefromPreviousPage: true,
                    previousMeetingData,
                    meetingId,
                  }}
                  style={{ textDecoration: "none" }}
                >
                  {" "}
                  <button
                    className="btn add-btn Mom-btn d-flex align-items-center justify-content-center btn btn-primary filter-height"
                    onClick={handleClick}
                  >
                    {" "}
                    <p>Create Follow On</p>{" "}
                  </button>
                </Link>
              </div>
            ) : null}

            {meeting ? (
              <div className="d-inline-block menu-dropdown custom-dropdown ">
                <div className="dropdown">
                  <div className="d-inline-block menu-dropdown custom-dropdown">
                    <Dropdown>
                      <MeetingDropDown
                        meetingDetails={meeting}
                        meetingId={meeting?._id}
                        status={meeting?.meetingStatus?.status}
                        handleCancelModal={() => {
                          handleCancelModal(meeting?._id);
                        }}
                        handleResendMeetingDetailsModal={() => {
                          handleResendMeetingDetailsModal(meeting);
                        }}
                        handleRescheduleModal={() => {
                          handleRescheduleModal(meeting);
                        }}
                        handleCloseModal={() => {
                          handleCloseModal(meeting?._id);
                        }}
                        handleDeleteModal={() => {
                          handleDeleteModal(meeting?._id);
                        }}
                      />
                    </Dropdown>
                  </div>
                </div>
              </div>
            ) : null}
            <BackButton show={camefromPreviousPage} />
          </div>
        </div>

        {screenSize <= 768 ? (
          <div className="color-box-resp">
            <div className="responsive-table details-form resp-mt-2">
              {meetingData?.timeLineDatas?.length !== 0 ? (
                <section className="meeting">
                  <div className="meeting-page">
                    <div className="row">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
                        <div className="pt-0 view-timeline screen-768-less">
                          <form className="details-form p-0">
                            {" "}
                            {meetingData.loading ? (
                              <div
                                className="meeting-page "
                                style={{ textAlign: "center", paddingTop: 20 }}
                              >
                                <Loader />
                              </div>
                            ) : (
                              <>
                                {meetingData?.timeLineDatas
                                  ?.followonMeetingDetails?.length !== 0 &&
                                  meetingData?.timeLineDatas?.followonMeetingDetails?.map(
                                    (meeting, index) => {
                                      return (
                                        <div
                                          className="inner-detail-form timeline-pb"
                                          id={`meeting-${meeting._id}`}
                                        >
                                          {stateData?.meetingId ===
                                          meeting?._id ? (
                                            <>
                                              {meeting?.attendees?.some(
                                                (att) =>
                                                  att?._id ===
                                                    employeeData?.userData
                                                      ?._id ||
                                                  employeeData?.userData
                                                    ?.isAdmin
                                              ) ? (
                                                <Link
                                                  target="_blank"
                                                  to={
                                                    meeting?.meetingStatus
                                                      ?.status === "closed"
                                                      ? `/view-minute-detail/${meeting?._id}`
                                                      : `/view-meeting-details/${meeting?._id}`
                                                  }
                                                  state={{
                                                    camefromPreviousPage: true,
                                                    meetingId: props.meetingId,
                                                    isViewMeetingPage: true,
                                                  }}
                                                  style={{
                                                    textDecoration: "none",
                                                  }}
                                                >
                                                  <>
                                                    <div className="timeline-pb">
                                                      <div className="timeline-row-1 d-flex align-items-center justify-content-between">
                                                        <div className="icon-id d-flex align-items-center g-10">
                                                          <div className="meeting-count1">
                                                            <div
                                                              className="meeting-circle-add"
                                                              ref={
                                                                beforeLineRef
                                                              }
                                                            >
                                                              {index + 1}
                                                            </div>
                                                          </div>

                                                          {/* <span className="meeting-day meeting-by-user">
                                                            {meeting?.meetingId}
                                                          </span> */}

                                                          <p className="meeting-day meeting-id-bg">
                                                            {meeting?.meetingId}
                                                          </p>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                          <div className="responsive-badge">
                                                            <span
                                                              className={
                                                                meeting
                                                                  ?.meetingStatus
                                                                  ?.status ===
                                                                "scheduled"
                                                                  ? "badge  bg-opacity-10 scheduled-color"
                                                                  : meeting
                                                                        ?.meetingStatus
                                                                        ?.status ===
                                                                      "rescheduled"
                                                                    ? "badge  bg-opacity-10 rescheduled-color"
                                                                    : meeting
                                                                          ?.meetingStatus
                                                                          ?.status ===
                                                                        "closed"
                                                                      ? "badge  bg-opacity-10 closed-color"
                                                                      : meeting
                                                                            ?.meetingStatus
                                                                            ?.status ===
                                                                          "draft"
                                                                        ? "badge  bg-opacity-10 draft-color"
                                                                        : "badge  bg-opacity-10 canceled-color"
                                                              }
                                                            >
                                                              {meeting?.meetingStatus?.status
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                                meeting?.meetingStatus?.status?.slice(
                                                                  1
                                                                )}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div className="timeline-row-2 mt-2">
                                                        {/* <span className="meeting-day meeting-by-user">
                                                          {meeting?.title}
                                                        </span> */}
                                                        <TimelineHeader
                                                          meeting={meeting}
                                                        />
                                                        <div>
                                                          {meeting?.isActive ===
                                                          false ? (
                                                            <span className="badge canceled-color bg-opacity-10 deleted-icon mx-2">
                                                              Deleted
                                                            </span>
                                                          ) : (
                                                            <p></p>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </>
                                                </Link>
                                              ) : (
                                                <>
                                                  <div className="timeline-row-1 d-flex align-items-center justify-content-between">
                                                    <div className="icon-id d-flex align-items-center g-10">
                                                      <div className="meeting-count1">
                                                        <div
                                                          className="meeting-circle-add"
                                                          ref={beforeLineRef}
                                                        >
                                                          {index + 1}
                                                        </div>
                                                      </div>
                                                      {/* <span>
                                                        {meeting?.meetingId}
                                                      </span> */}
                                                      <p className="meeting-day meeting-id-bg">
                                                        {meeting?.meetingId}
                                                      </p>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <div className="responsive-badge">
                                                        <span
                                                          className={
                                                            meeting
                                                              ?.meetingStatus
                                                              ?.status ===
                                                            "scheduled"
                                                              ? "badge  bg-opacity-10 scheduled-color"
                                                              : meeting
                                                                    ?.meetingStatus
                                                                    ?.status ===
                                                                  "rescheduled"
                                                                ? "badge  bg-opacity-10 rescheduled-color"
                                                                : meeting
                                                                      ?.meetingStatus
                                                                      ?.status ===
                                                                    "closed"
                                                                  ? "badge  bg-opacity-10 closed-color"
                                                                  : meeting
                                                                        ?.meetingStatus
                                                                        ?.status ===
                                                                      "draft"
                                                                    ? "badge  bg-opacity-10 draft-color"
                                                                    : "badge  bg-opacity-10 canceled-color"
                                                          }
                                                        >
                                                          {meeting?.meetingStatus?.status
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                            meeting?.meetingStatus?.status?.slice(
                                                              1
                                                            )}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="timeline-row-2 mt-2">
                                                    <TimelineHeader
                                                      meeting={meeting}
                                                    />
                                                    {/* <span>
                                                      {meeting?.title}
                                                    </span> */}
                                                    <div className="">
                                                      {meeting?.isActive ===
                                                      false ? (
                                                        <span className="badge canceled-color bg-opacity-10 deleted-icon mx-2">
                                                          Deleted
                                                        </span>
                                                      ) : (
                                                        <p></p>
                                                      )}
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {meeting?.attendees?.some(
                                                (att) =>
                                                  att?._id ===
                                                  employeeData?.userData?._id
                                              ) ||
                                              employeeData?.userData
                                                ?.isAdmin ? (
                                                <Link
                                                  target="_blank"
                                                  to={
                                                    meeting?.actionDetails &&
                                                    meeting?.meetingStatus
                                                      ?.status === "closed" &&
                                                    meeting?.actionDetails
                                                      ?.length !== 0
                                                      ? `/view-minute-detail/${meeting?._id}`
                                                      : `/view-meeting-details/${meeting?._id}`
                                                  }
                                                  state={{
                                                    meetingId: props.meetingId,
                                                    isViewMeetingPage: true,
                                                    camefromPreviousPage: true,
                                                  }}
                                                  style={{
                                                    textDecoration: "none",
                                                  }}
                                                  id={`meeting-${meeting._id}`}
                                                >
                                                  <>
                                                    <div className="timeline-row-1 d-flex align-items-center justify-content-between">
                                                      <div className="icon-id d-flex align-items-center g-10">
                                                        <div className="meeting-count1">
                                                          <div
                                                            className="meeting-circle-add"
                                                            ref={beforeLineRef}
                                                          >
                                                            {index + 1}
                                                          </div>
                                                        </div>
                                                        <p className="meeting-day meeting-id-bg">
                                                          {meeting?.meetingId}
                                                        </p>
                                                      </div>
                                                      <div className="d-flex align-items-center justify-content-between">
                                                        <div className="responsive-badge">
                                                          <span
                                                            className={
                                                              meeting
                                                                ?.meetingStatus
                                                                ?.status ===
                                                              "scheduled"
                                                                ? "badge  bg-opacity-10 scheduled-color"
                                                                : meeting
                                                                      ?.meetingStatus
                                                                      ?.status ===
                                                                    "rescheduled"
                                                                  ? "badge  bg-opacity-10 rescheduled-color"
                                                                  : meeting
                                                                        ?.meetingStatus
                                                                        ?.status ===
                                                                      "closed"
                                                                    ? "badge  bg-opacity-10 closed-color"
                                                                    : meeting
                                                                          ?.meetingStatus
                                                                          ?.status ===
                                                                        "draft"
                                                                      ? "badge  bg-opacity-10 draft-color"
                                                                      : "badge  bg-opacity-10 canceled-color"
                                                            }
                                                          >
                                                            {meeting?.meetingStatus?.status
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                              meeting?.meetingStatus?.status?.slice(
                                                                1
                                                              )}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="timeline-row-2 mt-2">
                                                      <TimelineHeader
                                                        meeting={meeting}
                                                      />
                                                      {/* <span className="">
                                                        {meeting?.title}
                                                      </span> */}
                                                      <div className="">
                                                        {meeting?.isActive ===
                                                        false ? (
                                                          <p className="badge canceled-color bg-opacity-10 deleted-icon">
                                                            Deleted
                                                          </p>
                                                        ) : (
                                                          <p></p>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </>
                                                </Link>
                                              ) : (
                                                <>
                                                  <div className="timeline-row-1 d-flex align-items-center justify-content-between">
                                                    <div className="icon-id d-flex align-items-center g-10">
                                                      <div
                                                        className="meeting-count1"
                                                        id={`meeting-${meeting._id}`}
                                                      >
                                                        <div
                                                          className="meeting-circle-add"
                                                          ref={beforeLineRef}
                                                        >
                                                          {index + 1}
                                                        </div>
                                                      </div>
                                                      <p className="meeting-day meeting-id-bg">
                                                        {meeting?.meetingId}
                                                      </p>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <div className="responsive-badge">
                                                        <span
                                                          className={
                                                            meeting
                                                              ?.meetingStatus
                                                              ?.status ===
                                                            "scheduled"
                                                              ? "badge  bg-opacity-10 scheduled-color"
                                                              : meeting
                                                                    ?.meetingStatus
                                                                    ?.status ===
                                                                  "rescheduled"
                                                                ? "badge  bg-opacity-10 rescheduled-color"
                                                                : meeting
                                                                      ?.meetingStatus
                                                                      ?.status ===
                                                                    "closed"
                                                                  ? "badge  bg-opacity-10 closed-color"
                                                                  : meeting
                                                                        ?.meetingStatus
                                                                        ?.status ===
                                                                      "draft"
                                                                    ? "badge  bg-opacity-10 draft-color"
                                                                    : "badge  bg-opacity-10 canceled-color"
                                                          }
                                                        >
                                                          {meeting?.meetingStatus?.status
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                            meeting?.meetingStatus?.status?.slice(
                                                              1
                                                            )}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="timeline-row-2 mt-2 d-flex justify-content-between">
                                                    <TimelineHeader
                                                      meeting={meeting}
                                                    />
                                                    {/* <span>
                                                      {meeting?.title}
                                                    </span> */}
                                                    <div>
                                                      {meeting?.isActive ===
                                                      false ? (
                                                        <span className="badge canceled-color bg-opacity-10 deleted-icon mx-2">
                                                          Deleted
                                                        </span>
                                                      ) : (
                                                        <p></p>
                                                      )}
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                            </>
                                          )}

                                          <div className="timeline-row-3 mt-2">
                                            {meeting?.actionDetails &&
                                            meeting?.actionDetails?.length !==
                                              0 ? (
                                              <Accordion
                                                defaultActiveKey="0"
                                                className="to-maintain-height"
                                                activeKey={activeKey}
                                              >
                                                <Accordion.Item
                                                  eventKey={index.toString()}
                                                  key={index}
                                                  className="agenda-accordion view-meeting-accordion"
                                                >
                                                  <Accordion.Header
                                                    onClick={() =>
                                                      handleToggle(
                                                        index.toString()
                                                      )
                                                    }
                                                  >
                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                      <p>Minutes Details</p>
                                                      &nbsp;
                                                      <span className="badge agenda-span timeline-counter-badge">
                                                        {
                                                          meeting?.actionDetails
                                                            ?.length
                                                        }
                                                      </span>
                                                    </div>
                                                  </Accordion.Header>
                                                  <Accordion.Body
                                                    ref={accordionBodyRef}
                                                  >
                                                    {meeting?.actionDetails
                                                      ?.length > 0 ? (
                                                      <div className="table-responsive responsive-table mt-0">
                                                        <table
                                                          className="table table-striped no-border timeline-table-list"
                                                          style={{
                                                            border: "none",
                                                          }}
                                                        >
                                                          <thead className="table">
                                                            <tr
                                                              style={{
                                                                border: "none",
                                                              }}
                                                            >
                                                              <th
                                                                scope="col"
                                                                className="center-text"
                                                              >
                                                                Sl No.
                                                              </th>
                                                              <th
                                                                scope="col"
                                                                className="left-text"
                                                              >
                                                                Action Title
                                                              </th>
                                                              <th
                                                                scope="col"
                                                                className="center-text"
                                                              >
                                                                Action Status
                                                              </th>
                                                              <th
                                                                scope="col"
                                                                className="center-text"
                                                              >
                                                                Assign
                                                                Personssssssssss
                                                              </th>
                                                              <th
                                                                scope="col"
                                                                className="center-text"
                                                              >
                                                                Due Date
                                                              </th>
                                                              <th
                                                                scope="col"
                                                                className="center-text"
                                                              >
                                                                Comments Count
                                                              </th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            {meeting.actionDetails.map(
                                                              (minute, idx) => (
                                                                <tr key={idx}>
                                                                  <td
                                                                    data-label="Sl.No"
                                                                    className="meeting-td-width-9 center-text"
                                                                  >
                                                                    {idx + 1}
                                                                  </td>

                                                                  <td
                                                                    data-label="Action Title"
                                                                    className="meeting-td-width word-break timeline-action-title"
                                                                  >
                                                                    {stateData?.actionId ===
                                                                    minute?._id ? (
                                                                      <div className="timeline-name">
                                                                        {minute
                                                                          ?.title
                                                                          ?.length >
                                                                        75 ? (
                                                                          <OverlayTrigger
                                                                            trigger={[
                                                                              "hover",
                                                                              "focus",
                                                                            ]}
                                                                            placement="top"
                                                                            overlay={popoverHoverFocus(
                                                                              minute?.title
                                                                            )}
                                                                          >
                                                                            <span className="meeting-title-hover">
                                                                              {`${sliceTextFromHTML(
                                                                                minute?.title,
                                                                                0,
                                                                                75
                                                                              )}....`}
                                                                            </span>
                                                                          </OverlayTrigger>
                                                                        ) : (
                                                                          minute?.title
                                                                        )}
                                                                      </div>
                                                                    ) : (
                                                                      <Link
                                                                        target="_blank"
                                                                        to={`/view-action-detail/${minute?._id}`}
                                                                        style={{
                                                                          textDecoration:
                                                                            "none",
                                                                          color:
                                                                            "black",
                                                                        }}
                                                                      >
                                                                        <div>
                                                                          {minute
                                                                            ?.title
                                                                            ?.length >
                                                                          75 ? (
                                                                            <OverlayTrigger
                                                                              trigger={[
                                                                                "hover",
                                                                                "focus",
                                                                              ]}
                                                                              placement="top"
                                                                              overlay={popoverHoverFocus(
                                                                                minute?.title
                                                                              )}
                                                                            >
                                                                              <span className="meeting-title-hover">
                                                                                {`${sliceTextFromHTML(
                                                                                  minute?.title,
                                                                                  0,
                                                                                  75
                                                                                )}....`}
                                                                              </span>
                                                                            </OverlayTrigger>
                                                                          ) : (
                                                                            minute?.title
                                                                          )}
                                                                        </div>
                                                                      </Link>
                                                                    )}
                                                                  </td>

                                                                  <td
                                                                    data-label="Action Status"
                                                                    className="meeting-td-width-0 center-text"
                                                                  >
                                                                    {minute.actionStatus ===
                                                                      "COMPLETED" && (
                                                                      <span className="badge completed-color bg-opacity-10">
                                                                        Completed
                                                                      </span>
                                                                    )}
                                                                    {minute.actionStatus ===
                                                                      "REOPENED" && (
                                                                      <span className="badge reopened-color bg-opacity-10">
                                                                        Reopened
                                                                      </span>
                                                                    )}
                                                                    {minute.actionStatus ===
                                                                      "APPROVED" && (
                                                                      <span className="badge approved-color bg-opacity-10">
                                                                        Approved
                                                                      </span>
                                                                    )}
                                                                    {minute.actionStatus ===
                                                                      "PENDING" && (
                                                                      <span className="badge pending-color bg-opacity-10">
                                                                        Pending
                                                                      </span>
                                                                    )}
                                                                    {minute.actionStatus ===
                                                                      "REQUESTFORREASSIGN" && (
                                                                      <span className="badge forwardrequested-color bg-opacity-10">
                                                                        Forward
                                                                        Requested
                                                                      </span>
                                                                    )}
                                                                    {minute.actionStatus ===
                                                                      "REASSIGNED" && (
                                                                      <span className="badge reassigned-color bg-opacity-10">
                                                                        Forwarded
                                                                      </span>
                                                                    )}
                                                                    {minute.actionStatus ===
                                                                      "CANCELLED" && (
                                                                      <span className="badge canceled-color bg-opacity-10">
                                                                        Cancelled
                                                                      </span>
                                                                    )}
                                                                  </td>

                                                                  <td
                                                                    data-label="Assign Person"
                                                                    className="meeting-td-width-6 attendees-center center-text"
                                                                    onClick={(
                                                                      e
                                                                    ) => {
                                                                      setModalStatus(
                                                                        true,
                                                                        minute
                                                                      );
                                                                    }}
                                                                  >
                                                                    {minute
                                                                      ?.assignedUser
                                                                      ?.length >
                                                                      0 && (
                                                                      <div className="attendees for-768-screen">
                                                                        {minute.assignedUser
                                                                          .slice(
                                                                            0,
                                                                            5
                                                                          )
                                                                          .map(
                                                                            (
                                                                              assignedUser
                                                                            ) => (
                                                                              <OverlayTrigger
                                                                                key={
                                                                                  assignedUser?._id
                                                                                }
                                                                                placement="top"
                                                                                overlay={tooltip(
                                                                                  assignedUser
                                                                                )}
                                                                                trigger={[
                                                                                  "hover",
                                                                                  "focus",
                                                                                ]}
                                                                              >
                                                                                <div
                                                                                  className={`attendee-list attendee-list-circle ${
                                                                                    assignedUser?.profilePicture
                                                                                      ? ""
                                                                                      : "attendees-border"
                                                                                  }`}
                                                                                  style={{
                                                                                    backgroundColor:
                                                                                      assignedUser?.profilePicture
                                                                                        ? undefined
                                                                                        : getColorFromId(
                                                                                            assignedUser?._id
                                                                                          ),
                                                                                  }}
                                                                                >
                                                                                  {assignedUser?.profilePicture ? (
                                                                                    <img
                                                                                      src={`${process.env.REACT_APP_API_URL}${assignedUser.profilePicture}`}
                                                                                      alt=""
                                                                                      className="attendee-profile-picture icon-image profile-picture attendee-list-circle-img"
                                                                                      onError={(
                                                                                        e
                                                                                      ) => {
                                                                                        e.target.onerror =
                                                                                          null;
                                                                                        e.target.style.display =
                                                                                          "none";
                                                                                        e.target.parentElement.style.backgroundColor =
                                                                                          getColorFromId(
                                                                                            assignedUser?._id
                                                                                          );
                                                                                        e.target.parentElement.innerText =
                                                                                          customName(
                                                                                            assignedUser?.name
                                                                                          );
                                                                                      }}
                                                                                    />
                                                                                  ) : (
                                                                                    <span className="attendee-name">
                                                                                      {customName(
                                                                                        assignedUser?.name
                                                                                      )}
                                                                                    </span>
                                                                                  )}
                                                                                </div>
                                                                              </OverlayTrigger>
                                                                            )
                                                                          )}
                                                                      </div>
                                                                    )}
                                                                    {minute
                                                                      ?.assignedUser
                                                                      ?.length >
                                                                      5 && (
                                                                      <p className="m-0">
                                                                        +
                                                                        {minute
                                                                          ?.assignedUser
                                                                          ?.length -
                                                                          5}{" "}
                                                                        More
                                                                      </p>
                                                                    )}
                                                                  </td>

                                                                  <td
                                                                    data-label="Due Date"
                                                                    className="meeting-td-width-6 center-text"
                                                                  >
                                                                    {formatDate(
                                                                      minute?.mainDueDate
                                                                    )}
                                                                  </td>
                                                                  <td
                                                                    data-label="Comments Count"
                                                                    className="center-text"
                                                                  >
                                                                    <span className="comments-count-badge badge">
                                                                      {
                                                                        minute?.totalComments
                                                                      }
                                                                    </span>
                                                                  </td>
                                                                </tr>
                                                              )
                                                            )}
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    ) : (
                                                      <p>
                                                        No minutes details
                                                        available.
                                                      </p>
                                                    )}
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>
                                            ) : null}
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                              </>
                            )}
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              ) : !meetingData?.timeLineDatas?.loading &&
                (!meetingData?.timeLineDatas ||
                  meetingData?.timeLineDatas?.length === 0) ? (
                <div className="no-data-img mt-3">
                  <Alert
                    status={"info"}
                    message={"No data available."}
                    timeoutSeconds={0}
                  />
                  <NoDataFound dataType={"meeting"} />
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <Loader />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="responsive-table details-form resp-mt-2">
            {meetingData?.timeLineDatas?.length !== 0 ? (
              <section className="meeting p-0">
                <div className="meeting-page">
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
                      <div className=" pt-0 view-timeline">
                        <form className="details-form p-0">
                          {" "}
                          {meetingData.loading ? (
                            <div
                              className="meeting-page "
                              style={{ textAlign: "center", paddingTop: 20 }}
                            >
                              <Loader />
                            </div>
                          ) : (
                            <div className="inner-detail-form">
                              {meetingData?.timeLineDatas
                                ?.followonMeetingDetails?.length !== 0 &&
                                meetingData?.timeLineDatas?.followonMeetingDetails?.map(
                                  (meeting, index) => {
                                    return (
                                      <div
                                        id={`meeting-${meeting._id}`}
                                        className="meeting-1 timeline-pb timeline-table-list"
                                        ref={
                                          stateData?.meetingId === meeting?._id
                                            ? myDivRef
                                            : null
                                        }
                                      >
                                        {index + 1 ===
                                        meetingData?.timeLineDatas
                                          ?.followonMeetingDetails?.length ? (
                                          <div className="meeting-count1">
                                            <div
                                              className="meeting-circle-add"
                                              ref={beforeLineRef}
                                            >
                                              {index + 1}
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="meeting-count1">
                                            <div
                                              className="meeting-circle-add"
                                              ref={beforeLineRef}
                                            >
                                              {index + 1}
                                            </div>
                                          </div>
                                        )}

                                        <div className="meeting-1-details">
                                          <div>
                                            <div>
                                              {stateData?.meetingId ===
                                              meeting?._id ? (
                                                <>
                                                  {meeting?.attendees?.some(
                                                    (att) =>
                                                      att?._id ===
                                                        employeeData?.userData
                                                          ?._id ||
                                                      employeeData?.userData
                                                        ?.isAdmin
                                                  ) ? (
                                                    <Link
                                                      target="_blank"
                                                      to={
                                                        meeting?.actionDetails &&
                                                        meeting?.meetingStatus
                                                          ?.status ===
                                                          "closed" &&
                                                        meeting?.actionDetails
                                                          ?.length !== 0
                                                          ? `/view-minute-detail/${meeting?._id}`
                                                          : `/view-meeting-details/${meeting?._id}`
                                                      }
                                                      state={{
                                                        meetingId:
                                                          props.meetingId,
                                                        isViewMeetingPage: true,
                                                        camefromPreviousPage: true,
                                                      }}
                                                      style={{
                                                        textDecoration: "none",
                                                      }}
                                                    >
                                                      <div className="d-flex align-items-center justify-content-between resp-mt-2">
                                                        <div className="d-flex resp-flex-column">
                                                          <p className="meeting-day meeting-id-bg">
                                                            {meeting?.meetingId}
                                                          </p>
                                                          <TimelineHeader
                                                            meeting={meeting}
                                                          />
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                          {meeting?.isActive ===
                                                          false ? (
                                                            <span className="badge canceled-color bg-opacity-10 deleted-icon mx-2">
                                                              Deleted
                                                            </span>
                                                          ) : (
                                                            <p></p>
                                                          )}
                                                          <span
                                                            className={
                                                              meeting
                                                                ?.meetingStatus
                                                                ?.status ===
                                                              "scheduled"
                                                                ? "badge  bg-opacity-10 scheduled-color"
                                                                : meeting
                                                                      ?.meetingStatus
                                                                      ?.status ===
                                                                    "rescheduled"
                                                                  ? "badge  bg-opacity-10 rescheduled-color"
                                                                  : meeting
                                                                        ?.meetingStatus
                                                                        ?.status ===
                                                                      "closed"
                                                                    ? "badge  bg-opacity-10 closed-color"
                                                                    : meeting
                                                                          ?.meetingStatus
                                                                          ?.status ===
                                                                        "draft"
                                                                      ? "badge  bg-opacity-10 draft-color"
                                                                      : "badge  bg-opacity-10 canceled-color"
                                                            }
                                                          >
                                                            {meeting?.meetingStatus?.status
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                              meeting?.meetingStatus?.status?.slice(
                                                                1
                                                              )}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </Link>
                                                  ) : (
                                                    <div className="d-flex align-items-center justify-content-between resp-mt-2">
                                                      <div className="d-flex resp-flex-column">
                                                        <p className="meeting-day meeting-id-bg">
                                                          {meeting?.meetingId}
                                                        </p>
                                                        <TimelineHeader
                                                          meeting={meeting}
                                                        />
                                                      </div>
                                                      <div className="d-flex align-items-center justify-content-between">
                                                        {meeting?.isActive ===
                                                        false ? (
                                                          <span className="badge canceled-color bg-opacity-10 deleted-icon mx-2">
                                                            Deleted
                                                          </span>
                                                        ) : (
                                                          <p></p>
                                                        )}
                                                        <span
                                                          className={
                                                            meeting
                                                              ?.meetingStatus
                                                              ?.status ===
                                                            "scheduled"
                                                              ? "badge  bg-opacity-10 scheduled-color"
                                                              : meeting
                                                                    ?.meetingStatus
                                                                    ?.status ===
                                                                  "rescheduled"
                                                                ? "badge  bg-opacity-10 rescheduled-color"
                                                                : meeting
                                                                      ?.meetingStatus
                                                                      ?.status ===
                                                                    "closed"
                                                                  ? "badge  bg-opacity-10 closed-color"
                                                                  : meeting
                                                                        ?.meetingStatus
                                                                        ?.status ===
                                                                      "draft"
                                                                    ? "badge  bg-opacity-10 draft-color"
                                                                    : "badge  bg-opacity-10 canceled-color"
                                                          }
                                                        >
                                                          {meeting?.meetingStatus?.status
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                            meeting?.meetingStatus?.status?.slice(
                                                              1
                                                            )}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {meeting?.attendees?.some(
                                                    (att) =>
                                                      att?._id ===
                                                      employeeData?.userData
                                                        ?._id
                                                  ) ||
                                                  employeeData?.userData
                                                    ?.isAdmin ? (
                                                    <h6 className="meeting-day mb-0 ">
                                                      <Link
                                                        target="_blank"
                                                        to={
                                                          meeting?.actionDetails &&
                                                          meeting?.meetingStatus
                                                            ?.status ===
                                                            "closed" &&
                                                          meeting?.actionDetails
                                                            ?.length !== 0
                                                            ? `/view-minute-detail/${meeting?._id}`
                                                            : `/view-meeting-details/${meeting?._id}`
                                                        }
                                                        state={{
                                                          meetingId:
                                                            props.meetingId,
                                                          isViewMeetingPage: true,
                                                          camefromPreviousPage: true,
                                                        }}
                                                        style={{
                                                          textDecoration:
                                                            "none",
                                                          color: "#013583",
                                                        }}
                                                      >
                                                        <div className="d-flex align-items-center justify-content-between resp-mt-2">
                                                          <div className="d-flex resp-flex-column">
                                                            <p className="meeting-day meeting-id-bg">
                                                              {
                                                                meeting?.meetingId
                                                              }
                                                            </p>
                                                            <TimelineHeader
                                                              meeting={meeting}
                                                            />
                                                          </div>
                                                          <div className="d-flex align-items-center justify-content-between">
                                                            {meeting?.isActive ===
                                                            false ? (
                                                              <span className="badge canceled-color bg-opacity-10 deleted-icon mx-2">
                                                                Deleted
                                                              </span>
                                                            ) : (
                                                              <p></p>
                                                            )}
                                                            <span
                                                              className={
                                                                meeting
                                                                  ?.meetingStatus
                                                                  ?.status ===
                                                                "scheduled"
                                                                  ? "badge  bg-opacity-10 scheduled-color"
                                                                  : meeting
                                                                        ?.meetingStatus
                                                                        ?.status ===
                                                                      "rescheduled"
                                                                    ? "badge  bg-opacity-10 rescheduled-color"
                                                                    : meeting
                                                                          ?.meetingStatus
                                                                          ?.status ===
                                                                        "closed"
                                                                      ? "badge  bg-opacity-10 closed-color"
                                                                      : meeting
                                                                            ?.meetingStatus
                                                                            ?.status ===
                                                                          "draft"
                                                                        ? "badge  bg-opacity-10 draft-color"
                                                                        : "badge  bg-opacity-10 canceled-color"
                                                              }
                                                            >
                                                              {meeting?.meetingStatus?.status
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                                meeting?.meetingStatus?.status?.slice(
                                                                  1
                                                                )}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </Link>
                                                    </h6>
                                                  ) : (
                                                    <h6 className="meeting-day mb-0 mt-2">
                                                      <div className="d-flex align-items-center justify-content-between resp-mt-2">
                                                        <div className="d-flex resp-flex-column">
                                                          <p className="meeting-day meeting-id-bg">
                                                            {meeting?.meetingId}
                                                          </p>

                                                          <TimelineHeader
                                                            meeting={meeting}
                                                          />
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                          {meeting?.isActive ===
                                                          false ? (
                                                            <span className="badge canceled-color bg-opacity-10 deleted-icon mx-2">
                                                              Deleted
                                                            </span>
                                                          ) : (
                                                            <p></p>
                                                          )}
                                                          <span
                                                            className={
                                                              meeting
                                                                ?.meetingStatus
                                                                ?.status ===
                                                              "scheduled"
                                                                ? "badge  bg-opacity-10 scheduled-color"
                                                                : meeting
                                                                      ?.meetingStatus
                                                                      ?.status ===
                                                                    "rescheduled"
                                                                  ? "badge  bg-opacity-10 rescheduled-color"
                                                                  : meeting
                                                                        ?.meetingStatus
                                                                        ?.status ===
                                                                      "closed"
                                                                    ? "badge  bg-opacity-10 closed-color"
                                                                    : meeting
                                                                          ?.meetingStatus
                                                                          ?.status ===
                                                                        "draft"
                                                                      ? "badge  bg-opacity-10 draft-color"
                                                                      : "badge  bg-opacity-10 canceled-color"
                                                            }
                                                          >
                                                            {meeting?.meetingStatus?.status
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                              meeting?.meetingStatus?.status?.slice(
                                                                1
                                                              )}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </h6>
                                                  )}
                                                </>
                                              )}
                                            </div>
                                          </div>
                                          <div>
                                            <h6 className="mt-1 meeting-time"></h6>
                                          </div>
                                          <div
                                            style={{
                                              transition: "height 0.3s ease",
                                            }}
                                          />
                                          {meeting?.actionDetails &&
                                          meeting?.actionDetails?.length !==
                                            0 ? (
                                            <Accordion
                                              defaultActiveKey="0"
                                              className="to-maintain-height"
                                              activeKey={activeKey}
                                            >
                                              <Accordion.Item
                                                eventKey={index.toString()}
                                                key={index}
                                                className="agenda-accordion view-meeting-accordion"
                                              >
                                                <Accordion.Header
                                                  onClick={() =>
                                                    handleToggle(
                                                      index.toString()
                                                    )
                                                  }
                                                >
                                                  <div className="d-flex align-items-center justify-content-between w-100">
                                                    <p>Minutes Details</p>
                                                    &nbsp;
                                                    <span className="badge agenda-span timeline-counter-badge">
                                                      {
                                                        meeting?.actionDetails
                                                          ?.length
                                                      }
                                                    </span>
                                                  </div>
                                                </Accordion.Header>
                                                <Accordion.Body
                                                  ref={accordionBodyRef}
                                                >
                                                  {meeting?.actionDetails
                                                    ?.length > 0 ? (
                                                    <div className="table-responsive responsive-table mt-0">
                                                      <table className="table table-striped timeline-accordion-table timeline-table-list">
                                                        <thead className="table">
                                                          <tr>
                                                            <th
                                                              scope="col"
                                                              className="center-text"
                                                            >
                                                              Sl No.
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="left-text"
                                                            >
                                                              Action Title
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="center-text"
                                                            >
                                                              Action Status
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="center-text"
                                                            >
                                                              Assign Person
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="center-text"
                                                            >
                                                              Due Date
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="center-text"
                                                            >
                                                              Comments Count
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {meeting.actionDetails.map(
                                                            (minute, idx) => (
                                                              <tr key={idx}>
                                                                <td
                                                                  data-label="Sl.No"
                                                                  className="meeting-td-width-9 center-text"
                                                                >
                                                                  {idx + 1}
                                                                </td>

                                                                <td
                                                                  data-label="Action Title"
                                                                  className="meeting-td-width word-break p-break-lenght timeline-action-title"
                                                                >
                                                                  {stateData?.actionId ===
                                                                  minute?._id ? (
                                                                    <div className="time-name">
                                                                      {minute
                                                                        ?.title
                                                                        ?.length >
                                                                      75 ? (
                                                                        <OverlayTrigger
                                                                          trigger={[
                                                                            "hover",
                                                                            "focus",
                                                                          ]}
                                                                          placement="top"
                                                                          overlay={popoverHoverFocus(
                                                                            minute?.title
                                                                          )}
                                                                        >
                                                                          <span className="meeting-title-hover">
                                                                            {`${sliceTextFromHTML(
                                                                              minute?.title,
                                                                              0,
                                                                              75
                                                                            )}....`}
                                                                          </span>
                                                                        </OverlayTrigger>
                                                                      ) : (
                                                                        minute?.title
                                                                      )}
                                                                    </div>
                                                                  ) : (
                                                                    <Link
                                                                      target="_blank"
                                                                      to={`/view-action-detail/${minute?._id}`}
                                                                      style={{
                                                                        textDecoration:
                                                                          "none",
                                                                        color:
                                                                          "black",
                                                                      }}
                                                                    >
                                                                      <div>
                                                                        {minute
                                                                          ?.title
                                                                          ?.length >
                                                                        75 ? (
                                                                          <OverlayTrigger
                                                                            trigger={[
                                                                              "hover",
                                                                              "focus",
                                                                            ]}
                                                                            placement="top"
                                                                            overlay={popoverHoverFocus(
                                                                              minute?.title
                                                                            )}
                                                                          >
                                                                            <span className="meeting-title-hover">
                                                                              {`${sliceTextFromHTML(
                                                                                minute?.title,
                                                                                0,
                                                                                75
                                                                              )}....`}
                                                                            </span>
                                                                          </OverlayTrigger>
                                                                        ) : (
                                                                          minute?.title
                                                                        )}
                                                                      </div>
                                                                    </Link>
                                                                  )}
                                                                </td>

                                                                <td
                                                                  data-label="Action Status"
                                                                  className="meeting-td-width-0 center-text"
                                                                >
                                                                  {minute.actionStatus ===
                                                                    "COMPLETED" && (
                                                                    <span className="badge completed-color bg-opacity-10">
                                                                      Completed
                                                                    </span>
                                                                  )}
                                                                  {minute.actionStatus ===
                                                                    "REOPENED" && (
                                                                    <span className="badge reopened-color bg-opacity-10">
                                                                      Reopened
                                                                    </span>
                                                                  )}
                                                                  {minute.actionStatus ===
                                                                    "APPROVED" && (
                                                                    <span className="badge approved-color bg-opacity-10">
                                                                      Approved
                                                                    </span>
                                                                  )}
                                                                  {minute.actionStatus ===
                                                                    "PENDING" && (
                                                                    <span className="badge pending-color bg-opacity-10">
                                                                      Pending
                                                                    </span>
                                                                  )}
                                                                  {minute.actionStatus ===
                                                                    "REQUESTFORREASSIGN" && (
                                                                    <span className="badge forwardrequested-color bg-opacity-10">
                                                                      Forward
                                                                      Requested
                                                                    </span>
                                                                  )}
                                                                  {minute.actionStatus ===
                                                                    "REASSIGNED" && (
                                                                    <span className="badge reassigned-color bg-opacity-10">
                                                                      Forwarded
                                                                    </span>
                                                                  )}
                                                                  {minute.actionStatus ===
                                                                    "CANCELLED" && (
                                                                    <span className="badge canceled-color bg-opacity-10">
                                                                      Cancelled
                                                                    </span>
                                                                  )}
                                                                </td>

                                                                <td
                                                                  data-label="Assign Person"
                                                                  className="meeting-td-width-6 attendees-center center-text"
                                                                  onClick={(
                                                                    e
                                                                  ) => {
                                                                    setModalStatus(
                                                                      true,
                                                                      minute
                                                                    );
                                                                  }}
                                                                >
                                                                  <>
                                                                    {minute
                                                                      ?.assignedUser
                                                                      ?.length >
                                                                      0 && (
                                                                      <div className="attendees">
                                                                        {minute.assignedUser
                                                                          .slice(
                                                                            0,
                                                                            5
                                                                          )
                                                                          .map(
                                                                            (
                                                                              assignedUser
                                                                            ) => (
                                                                              <OverlayTrigger
                                                                                key={
                                                                                  assignedUser?._id
                                                                                }
                                                                                placement="top"
                                                                                overlay={tooltip(
                                                                                  assignedUser
                                                                                )}
                                                                                trigger={[
                                                                                  "hover",
                                                                                  "focus",
                                                                                ]}
                                                                              >
                                                                                <div
                                                                                  className={`attendee-list attendee-list-circle ${
                                                                                    assignedUser?.profilePicture
                                                                                      ? ""
                                                                                      : "attendees-border"
                                                                                  }`}
                                                                                  style={{
                                                                                    backgroundColor:
                                                                                      assignedUser?.profilePicture
                                                                                        ? undefined
                                                                                        : getColorFromId(
                                                                                            assignedUser?._id
                                                                                          ),
                                                                                  }}
                                                                                >
                                                                                  {assignedUser?.profilePicture ? (
                                                                                    <img
                                                                                      src={`${process.env.REACT_APP_API_URL}${assignedUser.profilePicture}`}
                                                                                      alt=""
                                                                                      className="attendee-profile-picture icon-image profile-picture attendee-list-circle-img"
                                                                                      onError={(
                                                                                        e
                                                                                      ) => {
                                                                                        e.target.onerror =
                                                                                          null;
                                                                                        e.target.style.display =
                                                                                          "none";
                                                                                        e.target.parentElement.style.backgroundColor =
                                                                                          getColorFromId(
                                                                                            assignedUser?._id
                                                                                          );
                                                                                        e.target.parentElement.innerText =
                                                                                          customName(
                                                                                            assignedUser?.name
                                                                                          );
                                                                                      }}
                                                                                    />
                                                                                  ) : (
                                                                                    <span className="attendee-name">
                                                                                      {customName(
                                                                                        assignedUser?.name
                                                                                      )}
                                                                                    </span>
                                                                                  )}
                                                                                </div>
                                                                              </OverlayTrigger>
                                                                            )
                                                                          )}
                                                                      </div>
                                                                    )}
                                                                    {minute
                                                                      ?.assignedUser
                                                                      ?.length >
                                                                      5 && (
                                                                      <p className="m-0 plus-more-text">
                                                                        +
                                                                        {minute
                                                                          ?.assignedUser
                                                                          ?.length -
                                                                          5}{" "}
                                                                        More
                                                                      </p>
                                                                    )}
                                                                  </>
                                                                </td>

                                                                <td
                                                                  data-label="Due Date"
                                                                  className="meeting-td-width-6 center-text"
                                                                >
                                                                  {formatDate(
                                                                    minute?.mainDueDate
                                                                  )}
                                                                </td>
                                                                <td
                                                                  data-label="Comments Count"
                                                                  className="center-text"
                                                                >
                                                                  <span className="comments-count-badge badge badge-mr-0">
                                                                    {
                                                                      minute?.totalComments
                                                                    }
                                                                  </span>
                                                                </td>
                                                              </tr>
                                                            )
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  ) : (
                                                    <p>
                                                      No minutes details
                                                      available.
                                                    </p>
                                                  )}
                                                </Accordion.Body>
                                              </Accordion.Item>
                                            </Accordion>
                                          ) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}

                              {(isMeetingOrganiser === true ||
                                employeeData?.userData?.isAdmin === true ||
                                meetingData?.timeLineDatas?.parentMeetingDetails
                                  ?.createdById ===
                                  employeeData?.userData?._id) &&
                              meetingData?.timeLineDatas?.parentMeetingDetails
                                ?.meetingStatus?.status === "closed" ? (
                                <div className="meeting-3">
                                  <div className="meeting-count2">
                                    <div
                                      className="meeting-circle-add"
                                      ref={beforeLineRef}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        fill="white"
                                        className="bi bi-plus-lg"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                  {/* <div className="meeting-1-details">
                                    <button
                                      className="create-follow"
                                     
                                      onClick={handleClick} // Using the handleClick to detect key press
                                    >
                                      <Link
                                        to="/create-meeting"
                                        state={{
                                          followOnMeetingCount:
                                            followOnMeetingCount,
                                          isNewMeeting: true,
                                          parentMeetingData:
                                            meetingData?.timeLineDatas
                                              ?.parentMeetingDetails,
                                          followOnMeetings:
                                            meetingData.timeLineDatas
                                              .followonMeetingDetails,
                                          camefromPreviousPage: true,
                                          previousMeetingData,
                                          meetingId,
                                        }}
                                        style={{
                                          textDecoration: "none",
                                        }}
                                        id={`meeting-${meeting?._id}`}
                                      >
                                        <p>Create Follow On</p>
                                      </Link>
                                    </button>
                                  </div> */}
                                  <div className="meeting-1-details">
                                    <Link
                                      to="/create-meeting"
                                      state={{
                                        followOnMeetingCount,
                                        isNewMeeting: true,
                                        parentMeetingData:
                                          meetingData?.timeLineDatas
                                            ?.parentMeetingDetails,
                                        followOnMeetings:
                                          meetingData?.timeLineDatas
                                            ?.followonMeetingDetails,
                                        camefromPreviousPage: true,
                                        previousMeetingData,
                                        meetingId,
                                      }}
                                      id={`meeting-${meeting?._id}`}
                                      style={{ textDecoration: "none" }}
                                    >
                                      <button
                                        className="create-follow"
                                        onClick={handleClick} // optional if you want key press detection
                                      >
                                        <p>Create Follow On</p>
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            ) : !meetingData?.timeLineDatas?.loading &&
              (!meetingData?.timeLineDatas ||
                meetingData?.timeLineDatas?.length === 0) ? (
              <div className="no-data-img mt-3">
                <Alert
                  status={"info"}
                  message={"No data available."}
                  timeoutSeconds={0}
                />
                <NoDataFound dataType={"meeting"} />
              </div>
            ) : (
              <div>
                <Loader />
              </div>
            )}
          </div>
        )}
      </div>

      {isRescheduleModalOpen && (
        <RescheduleMeetingModal
          setIsRescheduleModalOpen={setIsRescheduleModalOpen}
          isRescheduleModalOpen={isRescheduleModalOpen}
          meetingData={meeting}
          isFetchedMeetingList={false}
          parentMeetingDetails={
            meetingData?.timeLineDatas?.parentMeetingDetails
          }
        />
      )}
      <ResendMeetingDetailsModal
        isResendMeetingDetailsModalOpen={isResendMeetingDetailsModalOpen}
        setIsResendMeetingDetailsModalOpen={setIsResendMeetingDetailsModalOpen}
        meetingDetail={meeting}
      />

      <CancelMeetingModal
        setIsModalOpen={setIsCancelModalOpen}
        isModalOpen={isCancelModalOpen}
        handleSubmit={handleCancelMeeting}
      />
      <DeleteMeetingModal
        setIsModalOpen={setIsDeleteMeetingModalOpen}
        isModalOpen={isDeleteMeetingModalOpen}
        handleSubmit={handleDeleteMeeting}
      />
      <AssignedAttendeesModal
        IsModalOpen={isModalOpen}
        attendees={attendeesData}
        setIsModalOpen={setIsModalOpen}
        loginUserData={loginUserData}
        isShow={true}
      />
    </>
  );
};

export default TimelinePage;
